<template>
	<el-dialog
		top="5vh"
		:title="dialogControl.title"
		:visible.sync="dialogControl.visible"
		width="1200px"
		class="sing-synchroel-preview-dialog"
	>
		<div v-if="dialogControl.visible && dialogControl.iframeShow" class="w-w-1200px w-h-800px">
			<iframe
				style="border: none;"
				ref="scoreIframeRef"
				:src="`${RESOURCE_URL}?isThumb=${false}&music_id=${iframeMusicId}&isScreening=${true}&is_synchro=true`"
				width="1160px"
				height="780px"
			/>
		</div>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			id: '',
			iframeMusicId: '',
			dialogControl: {
				title: '跟唱同步预览',
				visible: false,
				iframeShow: false
			},
      RESOURCE_URL: ''
		}
	},
  mounted() {
    this.RESOURCE_URL =  window.location.hostname !== 'localhost' ? window.web_config.server_url + window.web_config.music_score_display_path : window.RESOURCE_URL
  },
	methods: {
		// 打开dialog
		// 数据重置
		openDialog(id) {
			this.iframeMusicId = id
			this.dialogControl.iframeShow = true
			this.dialogControl.visible = true
		}
	}
}
</script>

<style lang="scss" scoped>
.sing-synchro {
	width: 100%;
	height: 500px;
	background: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	z-index: 10;
}

.sing-synchro .music-name {
	font-size: 36px;
	color: #000;
	font-weight: 700;
}

.sing-synchro .music-lyric {
	width: 900px;
	height: 300px;
	margin-top: 30px;
	overflow-y: auto;
	scroll-behavior: smooth;
}
.sing-synchro .music-lyric .lyric-item {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;
	font-size: 30px;
	color: #868686;
}

.sing-synchro .music-lyric .lyric-item .active {
	color: #ff5e2a;
}

.sing-synchro .music-progress-bar {
	width: 1000px !important;
	height: 20px;
	/* background-color: #e9e9e9; */
	margin: 50px 0;
	display: flex;
	align-items: center;
}

.sing-synchro .music-functions {
	display: flex;
	align-items: center;
	justify-content: center;
}

.sing-synchro .music-functions .music-btn {
	margin-left: 20px;
	width: 60px;
	height: 60px;
	cursor: pointer;
}
.sing-synchro .music-functions .music-btn img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}
</style>
